<script setup lang="ts">
import BackstageIcon from '@/components/common/BackstageIcon.vue';
import { ModalHeaderType } from '@/features/excel-order-upload/types/modal-header.enums';
import type { IconValues } from '@/models/icons.enum';
import { computed } from 'vue';

interface Props {
  title: string;
  description?: string;
  icon?: IconValues;
  type?: ModalHeaderType;
}

const props = defineProps<Props>();

const iconWrapperClass = computed(() => {
  if (!props.type) return '';

  return `modal-title-row__icon-wrapper--${props.type}`;
});
</script>

<template>
  <div class="modal-title-row">
    <div v-if="icon" class="modal-title-row__icon-wrapper" :class="iconWrapperClass">
      <BackstageIcon :name="icon" class="modal-title-row__icon" />
    </div>
    <h2 class="modal-title">{{ title }}</h2>
  </div>
  <p v-if="description" class="modal-description">{{ description }}</p>
</template>

<style lang="scss" scoped>
.modal-title-row {
  display: flex;
  align-items: center;
  column-gap: 12px;

  &__icon-wrapper {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    &--error {
      background-color: var(--content-negative);

      :deep(i) {
        background-color: var(--secondary-text-color);
      }
    }

    &--info {
      background-color: var(--content-system-color);

      :deep(i) {
        background-color: white;
      }
    }
  }
}

.modal-title,
.modal-description {
  margin: 0;
  text-align: left;
}

.modal-title {
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.1;
}

.modal-description {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}
</style>
